export  const riseup=() => {
  var risesign = $(window);
  var timer=null;
  var that = this;
  clearTimeout(risesign.timer);
    var icur=0;
    var iTarget=0;
    risesign.timer=setTimeout(function(){
    icur=Math.round(parseInt(risesign.scrollTop()))
    console.log("top="+risesign.scrollTop())
  var	speed=(iTarget-icur)/1;
    speed=speed>0?Math.ceil(speed):Math.floor(speed);
    if(icur==iTarget){
      clearTimeout(risesign.timer)
    }
    else{
      risesign.scrollTop(icur+speed)
      riseup();
    }
    },30)
}


// WEBPACK FOOTER //
// ./src/common/js/riseup.js